// extracted by mini-css-extract-plugin
export var label = "_et-2";
export var slideContainer = "_et-0";
export var slider = "_et-1";